import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with defaults
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ==================== PATTI APIs ====================
export const getPattis = async () => {
  const response = await apiClient.get('/pattis');
  return response.data;
};

// ==================== DIRECTORY APIs ====================
export const getDirectory = async (pattiId = null, search = '', includeAll = false, status = null) => {
  const params = {};
  if (pattiId) params.patti_id = pattiId;
  if (search) params.search = search;
  if (includeAll) params.include_all = true;
  if (status) params.status = status;
  
  const response = await apiClient.get('/directory', { params });
  return response.data;
};

export const getDirectoryEntry = async (id) => {
  const response = await apiClient.get(`/directory/${id}`);
  return response.data;
};

export const createDirectoryEntry = async (data, isAdmin = false) => {
  const response = await apiClient.post('/directory', data, {
    params: { is_admin: isAdmin }
  });
  return response.data;
};

export const updateDirectoryEntry = async (id, data) => {
  const response = await apiClient.put(`/directory/${id}`, data);
  return response.data;
};

export const deleteDirectoryEntry = async (id) => {
  const response = await apiClient.delete(`/directory/${id}`);
  return response.data;
};

// ==================== GRIEVANCE APIs ====================
export const submitGrievance = async (data) => {
  const response = await apiClient.post('/grievances', data);
  return response.data;
};

export const getGrievances = async (status = null) => {
  const params = status ? { status } : {};
  const response = await apiClient.get('/grievances', { params });
  return response.data;
};

export const updateGrievanceStatus = async (id, status) => {
  const response = await apiClient.put(`/grievances/${id}/status`, { status });
  return response.data;
};

// ==================== NEWS APIs ====================
export const getNews = async (limit = 10, includeAll = false, status = null) => {
  const params = { limit };
  if (includeAll) params.include_all = true;
  if (status) params.status = status;
  const response = await apiClient.get('/news', { params });
  return response.data;
};

export const getNewsItem = async (id) => {
  const response = await apiClient.get(`/news/${id}`);
  return response.data;
};

export const createNews = async (data, isAdmin = false) => {
  const response = await apiClient.post('/news', data, {
    params: { is_admin: isAdmin }
  });
  return response.data;
};

export const updateNews = async (id, data) => {
  const response = await apiClient.put(`/news/${id}`, data);
  return response.data;
};

export const deleteNews = async (id) => {
  const response = await apiClient.delete(`/news/${id}`);
  return response.data;
};

// ==================== EVENTS APIs ====================
export const getEvents = async (upcomingOnly = false, includeAll = false, status = null) => {
  const params = {};
  if (upcomingOnly) params.upcoming_only = true;
  if (includeAll) params.include_all = true;
  if (status) params.status = status;
  const response = await apiClient.get('/events', { params });
  return response.data;
};

export const getEvent = async (id) => {
  const response = await apiClient.get(`/events/${id}`);
  return response.data;
};

export const createEvent = async (data, isAdmin = false) => {
  const response = await apiClient.post('/events', data, {
    params: { is_admin: isAdmin }
  });
  return response.data;
};

export const updateEvent = async (id, data) => {
  const response = await apiClient.put(`/events/${id}`, data);
  return response.data;
};

export const deleteEvent = async (id) => {
  const response = await apiClient.delete(`/events/${id}`);
  return response.data;
};

// ==================== GALLERY APIs ====================
export const getGallery = async () => {
  const response = await apiClient.get('/gallery');
  return response.data;
};

export const addGalleryImage = async (url, captionEn, captionPa) => {
  const response = await apiClient.post('/gallery', null, {
    params: { url, caption_en: captionEn, caption_pa: captionPa }
  });
  return response.data;
};

export const deleteGalleryImage = async (id) => {
  const response = await apiClient.delete(`/gallery/${id}`);
  return response.data;
};

// ==================== SERVICES APIs ====================
export const getServices = async (type = null) => {
  const params = type ? { type } : {};
  const response = await apiClient.get('/services', { params });
  return response.data;
};

export const getService = async (id) => {
  const response = await apiClient.get(`/services/${id}`);
  return response.data;
};

export const createService = async (data) => {
  const response = await apiClient.post('/services', data);
  return response.data;
};

export const updateService = async (id, data) => {
  const response = await apiClient.put(`/services/${id}`, data);
  return response.data;
};

export const deleteService = async (id) => {
  const response = await apiClient.delete(`/services/${id}`);
  return response.data;
};

// ==================== TRIBUTE APIs (Shradhanjali, Birthday, Anniversary) ====================
export const getTributes = async (type = null, includeAll = false, status = null, activeOnly = false) => {
  const params = {};
  if (type) params.type = type;
  if (includeAll) params.include_all = true;
  if (status) params.status = status;
  if (activeOnly) params.active_only = true;
  const response = await apiClient.get('/tributes', { params });
  return response.data;
};

export const getHomepageTributes = async () => {
  const response = await apiClient.get('/tributes/homepage');
  return response.data;
};

export const getTribute = async (id) => {
  const response = await apiClient.get(`/tributes/${id}`);
  return response.data;
};

export const createTribute = async (data, isAdmin = false) => {
  const response = await apiClient.post('/tributes', data, {
    params: { is_admin: isAdmin }
  });
  return response.data;
};

export const updateTribute = async (id, data) => {
  const response = await apiClient.put(`/tributes/${id}`, data);
  return response.data;
};

export const deleteTribute = async (id) => {
  const response = await apiClient.delete(`/tributes/${id}`);
  return response.data;
};

export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post('/upload-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export default apiClient;
